module.exports = __webpack_public_path__ + "img/bggrid.5253e748.jpg";